var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"row",attrs:{"variant":_vm.color(_vm.checklist.status),"dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_c('b',[_vm._v(_vm._s(_vm.$t('checklist.attribute.status'))+" checklist: "+_vm._s(_vm.checklist.status ? _vm.checklist.status.name: '')+" ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f229cb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/alert-checklist/alert-checklist.html
// module id = null
// module chunks = 